import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Chip from '@material-ui/core/Chip';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import { logger } from './../../../utils/utils';
import { labels, regexes, invalidMessages } from './../../../constants';
import { users } from './../../../data';

const useStyles = makeStyles((theme) => ({
  chip: {
    display: 'flex',
    justifyContent: 'start',
    margin: 3,
    padding: '14px 4px',
    lineHeight: '15px',
    borderRadius: 20,
    width: '100%',
    fontSize: 16,
    backgroundColor: 'LightYellow',
  },
}));

const SelectMultipleEmails = (
  {
    name = 'selectMutipleEmails',
    label = labels.selectMultipleEmails,
    fieldOptions,
    defaultValues = [],
    // FIXME: fixedOptions value in parent load(async) finished after selectMutipleEmails render
    // TODO: Create fixedOptions state and set by ref
    // fixedOptions = [],
    onChange = undefined,
    disableClearable = true,
  },
  ref
) => {
  //// Log re-render
  logger('SelectMultipleEmails render');

  const classes = useStyles();

  // fieldOpts
  const fieldOpts = fieldOptions ? fieldOptions : { context: 'email' };

  // Set exist values to  defaultValues
  defaultValues = defaultValues
    ? defaultValues.map((email) => email[fieldOpts.context])
    : [];
  const selectRef = useRef();

  const [options, setOptions] = React.useState([]);
  const [values, setValues] = useState([...defaultValues]);
  const [isWrongFomatValue, setIsWrongFomatValue] = useState(false);
  // Async get ann set email data to options state.
  // Ref: https://v4.mui.com/components/autocomplete/#asynchronous-requests
  useEffect(() => {
    let active = true;
    let responseEmails = [];
    (async () => {
      responseEmails = await users.mockSearchEmails();

      if (active) {
        setOptions(responseEmails.map((option) => option[fieldOpts.context]));
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  // Set cursor in emails input.

  useEffect(() => {
    // https://stackoverflow.com/questions/53090432/react-hooks-right-way-to-clear-timeouts-and-intervals
    let timer = null;
    if (selectRef.current) {
      timer = setTimeout(() => {
        selectRef.current.focus();
      }, 1500);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [selectRef]);
  return (
    <React.Fragment>
      {/* Using Autocomplete-Asynchronous is Main-Component */}
      <Autocomplete
        id="select-multiple-emails"
        data-testid="select-multiple-emails"
        multiple
        freeSolo
        value={values}
        options={options}
        renderTags={(value, getTagProps) => {
          return value.map((option, index) => (
            <Chip
              component="div"
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
              className={classes.chip}
            />
          ));
        }}
        renderInput={(params) => {
          return (
            <Field
              {...params}
              variant="filled"
              component={TextField}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isWrongFomatValue ? (
                      <>
                        <span style={{ color: 'red' }}>
                          {invalidMessages.emailFormat}
                        </span>
                        <HighlightOffOutlinedIcon
                          color="error"
                          fontSize="large"
                        />
                      </>
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              label={label}
              name={name}
              inputRef={selectRef}
            />
          );
        }}
        disableClearable={disableClearable}
        getOptionDisabled={(option) => {
          return values.includes(option);
        }}
        onInputChange={(e, val) => {
          const isWrongFomatEmail = val.match(regexes.emailFormat) === null;
          if (isWrongFomatEmail && val) {
            setIsWrongFomatValue(true);
          } else {
            setIsWrongFomatValue(false);
          }
        }}
        onChange={(e, newValue) => {
          // Validate mail of free solo value (byuser)
          const isWrongFomatEmails = newValue.filter(
            (email) => email.match(regexes.emailFormat) === null
          );
          if (isWrongFomatEmails.length) {
            console.error(
              'email wrong format: ',
              isWrongFomatEmails.join(', ')
            );
            return false;
          } else {
            setValues(newValue);
            if (onChange) {
              onChange(newValue);
            }
          }
        }}
      />
      {/* <div>
        {' '}
        <ul>
          {usurs.map((option) => (
            <li key={option}>{option}</li>
          ))}
        </ul>
      </div> */}
    </React.Fragment>
  );
};

export default React.memo(SelectMultipleEmails);
